export { default } from './RubberCustomerCreateAndUpdateModal'
